<template>
	<v-container fluid>
  
	  <v-snackbar v-model="snackbar" :color="snackbarColor" :top="true" :right="true" :timeout="6000">
  
		{{ message }}
  
		<v-btn dark text @click="snackbar = false">
  
		  CLOSE
  
		</v-btn>
  
	  </v-snackbar>
  
	  <v-layout row wrap>
  
		<v-flex xs6>
  
		  <p class="white--text tdate"> {{ todaysDate }} </p>
  
		  <p class="white--text activity"> Your activity for today </p>
  
		</v-flex>
  
	  </v-layout>
	  <v-layout row wrap ml-3>
		<!-- <v-flex xs2 style="padding: 3px"  >
			<v-card raised height="155px" class="card">
			  <v-card-text class="text-center">
				  <span class="accentd--text cardtext"> Parchment Timer </span>
				  <p class="accentd--text cardtext">  {{ daysParchment }} Days {{ hoursParchment }} Hrs {{ minutesParchment }} Mins {{ secondsParchment  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }}  </p>
  
			  </v-card-text>
			</v-card>
		  </v-flex>  -->
		<!-- <v-flex xs2 style="padding: 3px"  >
			<v-card raised height="155px" class="card">
			  <v-card-text class="text-center">
				  <span class="accentd--text cardtext"> Dispatch Timer </span>
				  <p class="accentd--text cardtext"> {{ daysDispatch }} Days {{ hoursDispatch }} Hrs {{ minutesDispatch }} Mins {{ secondsDispatch  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }}  </p>
  
			  </v-card-text>
			</v-card>
		  </v-flex>  -->
		<!-- <v-flex xs2 style="padding: 3px"  v-if="displayTimerCleanCoffee">
		  <v-card raised height="155px" class="card" v-if="displayTimerCleanCoffee">
			<v-card-text class="text-center">
				<span class="accentd--text cardtext"> Clean Coffee Timer </span>
				<p class="accentd--text cardtext">  {{ daysCleanCoffee }} Days {{ hoursCleanCoffee }} Hrs {{ minutesCleanCoffee }} Mins {{ secondsCleanCoffee  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }}  </p>
  
			</v-card-text>
		  </v-card>
		</v-flex>   -->
		<!-- <v-flex xs2 style="padding: 3px" v-if="displayTimerCatalogue">
		  <v-card raised height="155px" class="card" v-if="displayTimerCatalogue">
			<v-card-text class="text-center">
				<span class="accentd--text cardtext"> Catalogue Timer </span>
				<p class="accentd--text cardtext">  {{ daysCatalogue }} Days {{ hoursCatalogue }} Hrs {{ minutesCatalogue }} Mins {{ secondsCatalogue  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }}   </p>
			  </v-card-text>
		  </v-card>
		</v-flex>   -->
		<!-- <v-flex xs2 style="padding: 3px" v-if="displayTimerAuction">
		  <v-card raised height="155px" class="card" v-if="displayTimerAuction ">
			<v-card-text class="text-center">
				<span class="accentd--text cardtext"> Auction Timer </span>
				<p class="accentd--text cardtext">  {{ daysCatalogue }} Days {{ hoursCatalogue }} Hrs {{ minutesCatalogue }} Mins {{ secondsCatalogue  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }}   </p>
			  </v-card-text>
		  </v-card>
		</v-flex>  -->
	  </v-layout>
  
	</v-container>
  </template>
  
  <script>
  import axios from 'axios'
  import config from '../../config'
  export default {
	  name: 'CoopMakerDash',
	  components: {},
	  data: function () {
		  return {
			  message: '',
			  snackbar: false,
			  snackbarColor: '',
			  remainingTime: 0,
			  targetDate: '',
			  days: 0,
			  hours: 0,
			  minutes: 0,
			  seconds: 0,
			  remainingTimeParchment: 0,
			  remainingTimeDispatch: 0,
			  remainingTimeCleanCoffee: 0,
			  remainingTimeCatalogue: 0,
			  remainingTimeAuction: 0,
			  targetDateParchment: '',
			  targetDateDispatch: '',
			  targetDateCleanCoffee: '',
			  targetDateCatalogue: '',
			  targetDateAuction: '',
			  displayTimerParchment: true,
			  displayTimerDispatch: true,
			  displayTimerCleanCoffee: true,
			  displayTimerCatalogue: true,
			  displayTimerAuction: true,
			  interval: null,
			  days: 0,
			  hours: 0,
			  minutes: 0,
			  seconds: 0,
			  daysParchment: 0,
			  hoursParchment: 0,
			  minutesParchment: 0,
			  secondsParchment: 0,
			  daysDispatch: 0,
			  hoursDispatch: 0,
			  minutesDispatch: 0,
			  secondsDispatch: 0,
			  daysCleanCoffee: 0,
			  hoursCleanCoffee: 0,
			  minutesCleanCoffee: 0,
			  secondsCleanCoffee: 0,
			  daysCatalogue: 0,
			  hoursCatalogue: 0,
			  minutesCatalogue: 0,
			  secondsCatalogue: 0,
			  daysAuction: 0,
			  hoursAuction: 0,
			  minutesAuction: 0,
			  secondsAcution: 0,
			  isDashboard: false,
			  saleNo: '',
			  saleDate: '',
			  interval: null
		  }
	  },
	  async mounted () {
		  this.startCountdown()
		  await this.getUpcomingDate()
		  console.log('Host    ' + config.serverURI)
	  },
	  computed: {
		  todaysDate: function () {
			  const now = new Date()
			  const options = {
				  day: 'numeric',
				  month: 'short',
				  weekday: 'long',
				  year: 'numeric'
			  }
			  return now.toLocaleString('en-us', options)
		  }
	  },
	  methods: {
		  startCountdown () {
			  this.interval = setInterval(this.updateParchmentCountdown, 1000)
			  this.interval = setInterval(this.updateDispatchCountdown, 1000)
			  this.interval = setInterval(this.updateCleanCoffeeCountdown, 1000)
			  this.interval = setInterval(this.updateCatalogueCountdown, 1000)
			  this.interval = setInterval(this.updateAuctionCountdown, 1000)
		  },
		  updateParchmentCountdown () {
			  const now = new Date().getTime()
			  this.displayTimerParchment = this.targetDateParchment !== 0
  
			  const distanceParchment = this.targetDateParchment - now
			  if (distanceParchment < 0) {
				  clearInterval(this.interval)
				  // this.isUploadDisabled = true;
				  this.daysParchment = 0
				  this.hoursParchment = 0
				  this.minutesParchment = 0
				  this.secondsParchment = 0
				  return
			  }
			  this.daysParchment = Math.floor(distanceParchment / (1000 * 60 * 60 * 24))
			  this.hoursParchment = Math.floor((distanceParchment % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			  this.minutesParchment = Math.floor((distanceParchment % (1000 * 60 * 60)) / (1000 * 60))
			  this.secondsParchment = Math.floor((distanceParchment % (1000 * 60)) / 1000)
		  },
		  updateDispatchCountdown () {
			  const now = new Date().getTime()
			  this.displayTimerDispatch = this.targetDateDispatch !== 0
  
			  const distanceDispatch = this.targetDateDispatch - now
			  if (distanceDispatch < 0) {
				  this.daysDispatch = 0
				  this.hoursDispatch = 0
				  this.minutesDispatch = 0
				  this.secondsDispatch = 0
				  return
			  }
			  this.daysDispatch = Math.floor(distanceDispatch / (1000 * 60 * 60 * 24))
			  this.hoursDispatch = Math.floor((distanceDispatch % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			  this.minutesDispatch = Math.floor((distanceDispatch % (1000 * 60 * 60)) / (1000 * 60))
			  this.secondsDispatch = Math.floor((distanceDispatch % (1000 * 60)) / 1000)
		  },
		  updateCleanCoffeeCountdown () {
			  const now = new Date().getTime()
			  this.displayTimerCleanCoffee = this.targetDateCleanCoffee !== 0
  
			  const distanceCleanCoffee = this.targetDateCleanCoffee - now
			  if (distanceCleanCoffee < 0) {
				  this.daysCleanCoffee = 0
				  this.hoursCleanCoffee = 0
				  this.minutesCleanCoffee = 0
				  this.secondsCleanCoffee = 0
				  return
			  }
			  this.daysCleanCoffee = Math.floor(distanceCleanCoffee / (1000 * 60 * 60 * 24))
			  this.hoursCleanCoffee = Math.floor((distanceCleanCoffee % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			  this.minutesCleanCoffee = Math.floor((distanceCleanCoffee % (1000 * 60 * 60)) / (1000 * 60))
			  this.secondsCleanCoffee = Math.floor((distanceCleanCoffee % (1000 * 60)) / 1000)
		  },
		  updateCatalogueCountdown () {
			  const now = new Date().getTime()
			  this.displayTimerCatalogue = this.targetDateCatalogue !== 0
  
			  const distanceCatalogue = this.targetDateCatalogue - now
			  if (distanceCatalogue < 0) {
				  this.daysCatalogue = 0
				  this.hoursCatalogue = 0
				  this.minutesCatalogue = 0
				  this.secondsCatalogue = 0
				  return
			  }
			  this.daysCatalogue = Math.floor(distanceCatalogue / (1000 * 60 * 60 * 24))
			  this.hoursCatalogue = Math.floor((distanceCatalogue % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			  this.minutesCatalogue = Math.floor((distanceCatalogue % (1000 * 60 * 60)) / (1000 * 60))
			  this.secondsCatalogue = Math.floor((distanceCatalogue % (1000 * 60)) / 1000)
		  },
		  updateAuctionCountdown () {
			  const now = new Date().getTime()
			  this.displayTimerAuction = this.targetDateAuction !== 0
			  console.log(this.targetDateAuction)
			  const distanceAuction = this.targetDateAuction - now
			  if (distanceAuction < 0) {
				  this.daysAuction = 0
				  this.hoursAuction = 0
				  this.minutesAuction = 0
				  this.secondsAcution = 0
				  return
			  }
			  this.daysAuction = Math.floor(distanceAuction / (1000 * 60 * 60 * 24))
			  this.hoursAuction = Math.floor((distanceAuction % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			  this.minutesAuction = Math.floor((distanceAuction % (1000 * 60 * 60)) / (1000 * 60))
			  this.secondsAcution = Math.floor((distanceAuction % (1000 * 60)) / 1000)
		  },
		  async getUpcomingDate () {
			  const token = localStorage.getItem('token')
			  const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
			  const patchUpcomingDate = config.serverURI + '/timer/upcomingdatewh/PARCHMENT'
			  const dispatchUpcomingDate = config.serverURI + '/timer/upcomingdatewh/GRN'
			  const cleanCoffeeUpcomingDate = config.serverURI + '/timer/upcomingdatewh/CLEAN-COFFEE'
			  const catalogueUpcomingDate = config.serverURI + '/timer/upcomingdatewh/CATALOGUE'
			  const auctionUpcomingDate = config.serverURI + '/timer/upcomingdatewh/AUCTION'
  
			  const patchmentReq = axios.get(patchUpcomingDate, { tokenconfig })
			  const dispatchReq = axios.get(dispatchUpcomingDate, { tokenconfig })
			  const cleancoffeeReq = axios.get(cleanCoffeeUpcomingDate, { tokenconfig })
			  const catalogueReq = axios.get(catalogueUpcomingDate, { tokenconfig })
			  const auctionReq = axios.get(auctionUpcomingDate, { tokenconfig })
  
			  await axios
				  .all([patchmentReq, dispatchReq, cleancoffeeReq, catalogueReq, auctionReq])
				  .then(
					  axios.spread((...responses) => {
						  const patchmentResponse = responses[0]
						  const dispatchResponse = responses[1]
						  const cleancoffeeResponse = responses[2]
						  const catalogueResponse = responses[3]
						  const auctionResponse = responses[4]
  
						  this.targetDateParchment = patchmentResponse.data.timeInMillis
						  // this.targetDateParchment = new Date().getTime() + parseInt(this.remainingTimeParchment) * 60 * 1000
						  this.targetDateDispatch = dispatchResponse.data.timeInMillis
						  // this.targetDateDispatch = new Date().getTime() + parseInt(this.remainingTimeDispatch) * 60 * 1000
  
						  this.targetDateCleanCoffee = cleancoffeeResponse.data.timeInMillis
						  // this.targetDateCleanCoffee  = new Date().getTime() + parseInt(this.remainingTimeCleanCoffee) * 60 * 1000
  
						  this.targetDateCatalogue = catalogueResponse.data.timeInMillis
						  // this.targetDateCatalogue = new Date().getTime() + parseInt(this.remainingTimeCatalogue) * 60 * 1000
  
						  this.targetDateAuction = auctionResponse.data.timeInMillis
						  this.saleNo = dispatchResponse.data.saleNo
						  this.saleDate = dispatchResponse.data.saleDate
						  // this.targetDateAuction = new Date().getTime() + parseInt(this.remainingTimeAuction) * 60 * 1000
  
						  console.log('patchment Response :' + JSON.stringify(patchmentResponse.data))
						  console.log('dispatch Response :' + JSON.stringify(dispatchResponse.data))
						  console.log('clean coffee Response :' + JSON.stringify(cleancoffeeResponse.data))
						  // if (fileType === 'PARCHMENT') {
						  // 	this.remainingTimeParchment = response.data
						  // 	this.targetDateParchment = new Date().getTime() + parseInt(this.remainingTimeParchment) * 60 * 1000
						  // } else if (fileType === 'DISPATCH') {
						  // 	this.remainingTimeDispatch = response.data
						  // 	this.targetDateDispatch = new Date().getTime() + parseInt(this.remainingTimeDispatch) * 60 * 1000
						  // } else if (fileType === 'CLEANCOFFEE') {
						  // 	this.remainingTimeCleanCoffee = response.data
						  // 	this.targetDateCleanCoffee  = new Date().getTime() + parseInt(this.remainingTimeCleanCoffee) * 60 * 1000
						  // }
  
						  // this.targetDate = new Date().getTime() + parseInt(this.remainingTime) * 24 * 60 * 60 * 1000
					  })
				  )
				  .catch((errors) => {
					  console.log(errors)
				  })
		  }
	  }
  }
  </script>
  <style>
  .tdate {
	font-size: 24px;
	font-weight: 700;
	margin-bottom: 5px;
  }
  
  .activity {
	font-size: 18px;
	font-weight: 500;
  }
  
  .cataloguebtn {
	font-weight: 700;
	border-radius: 8px;
  }
  
  .activelink {
	background-image: linear-gradient(to right, #FFFFFF, #F2D0A7, #FFFFFF);
  }
  
  .thead {
	background-color: #00513B !important;
	color: white;
	font-size: 12px;
  }
  
  .table tbody tr>td.actions {
	font-size: 20px !important;
	color: #733D29 !important;
	text-align: center;
	vertical-align: middle;
	padding-top: 0px;
  }
  
  .pagination {
	background-color: red;
  }
  
  .paginationtext {
	color: #733D29;
  }
  
  .pagination>li>a,
  .pagination>li>span {
	border: 1px solid #F2D0A7;
	color: #733D29;
  }
  
  .pagination>li.active>.page-link {
	background: #00513B;
	color: #fff;
  }
  
  .cataloguecard {
	background-image: linear-gradient(233deg, #FFFFFF, #F2D0A7);
  }
  
  .activecard {
	box-shadow: 0px 0px 16px #00513B;
  }
  
  .cardnumber {
	font-size: 30px;
	font-weight: 700;
  }
  
  .cardtext {
	font-weight: 500;
  }
  
  .cardlink {
	color: #733D29;
  }
  
  .invoicescard {
	background-image: linear-gradient(233deg, #FFFFFF, #F2D0A7);
  }
  </style>
  